import type { OfferLabelsTranslation } from '../../offer-labels-content';

export const offerLabels: OfferLabelsTranslation = {
  bestPlaceBadge: 'Consigliato',
  bestPriceBadge: 'Miglior prezzo',
};
